/**
 * SEE-271: Team members → verify. Confirms the unconfirmed Cognito sign-up of a
 * "Not signed up yet" member, served by the CDK v2-user Lambda. Primary admins of
 * the member's company and support users only (server-side assert_admin).
 */
export const adminVerifyMemberMutation = /* GraphQL */ `
  mutation AdminVerifyMember($input: AdminVerifyMemberInput!) {
    adminVerifyMember(input: $input) {
      paidolUserId
      verified
      reason
    }
  }
`;
